// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.api.web.handler.ZCalendarWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  DisableTouringForListingWebApiRequestDto,
  EnableTouringForListingWebApiRequestDto,
  EnableTouringForListingWebApiResponseDto,
  GetAvailabilityAndToursForListingWebApiRequestDto,
  GetAvailabilityAndToursForListingWebApiResponseDto,
  GetAvailabilityWebApiRequestDto,
  GetAvailabilityWebApiResponseDto,
  GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
  GetAvailableTimesForRescheduleByIreneWebApiResponseDto,
  GetTourConfigAndAvailabilityWebApiRequestDto,
  GetTourConfigAndAvailabilityWebApiResponseDto,
  GetTourForSatelliteConversationIdWebApiResponseDto,
  GetTouringTreatmentForZuidAndListingWebApiRequestDto,
  GetTouringTreatmentForZuidAndListingWebApiResponseDto,
  GetToursForListingWebApiRequestDto,
  GetToursForListingWebApiResponseDto,
  ListingAlias,
  PerformTourActionWebApiRequestDto,
  PerformTourActionWebApiResponseDto,
  RemoveAvailabilityWebApiRequestDto,
  RemoveAvailabilityWebApiResponseDto,
  SaveTourFeedbackWebApiRequestDto,
  SetAvailabilitiesLiteWebApiRequestDto,
  SetAvailabilityWebApiRequestDto,
  SetAvailabilityWebApiResponseDto,
  StoreListingCalendarTimeConfigWebApiRequestDto,
  StoreListingTimeZoneWebApiRequestDto,
  StoreListingTourDurationWebApiRequestDto,
  UpdateAvailabilityWebApiRequestDto,
  UpdateAvailabilityWebApiResponseDto,
} from '../..';

interface GetTourForSatelliteConversationIdParams {
  conversationId: string;
  listingAlias: ListingAlias;
}

export const ZCalendarWebApiHandler_disableTouringForListing_Path =
  '/api/web/v1/touring/config/disableTouringForListing';

/**
 * disables all tours for a listing
 */
export const ZCalendarWebApiHandler_disableTouringForListing = (
  postData: DisableTouringForListingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DisableTouringForListingWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_disableTouringForListing_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_enableTouringForListing_Path = '/api/web/v1/touring/config/enableTouringForListing';

/**
 * enable touring for a listing
 */
export const ZCalendarWebApiHandler_enableTouringForListing = (
  postData: EnableTouringForListingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, EnableTouringForListingWebApiRequestDto, EnableTouringForListingWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_enableTouringForListing_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getAvailability_Path = '/api/web/v1/touring/availability/getAvailability';

/**
 * get tour availability for a listing for a certain time period
 */
export const ZCalendarWebApiHandler_getAvailability = (
  postData: GetAvailabilityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetAvailabilityWebApiRequestDto, GetAvailabilityWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_getAvailability_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Path =
  '/api/web/v1/touring/getAvailabilityAndToursForListing';

/**
 * get availability and tours for full calendar
 */
export const ZCalendarWebApiHandler_getAvailabilityAndToursForListing = (
  postData: GetAvailabilityAndToursForListingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetAvailabilityAndToursForListingWebApiRequestDto,
    GetAvailabilityAndToursForListingWebApiResponseDto
  >(
    {
      endpoint: ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Path =
  '/api/web/v1/touring/scheduling/getAvailableTimesForRescheduleByIrene';

/**
 * get available times for reschedule by irene
 */
export const ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene = (
  postData: GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
    GetAvailableTimesForRescheduleByIreneWebApiResponseDto
  >(
    {
      endpoint: ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getTourConfigAndAvailability_Path =
  '/api/web/v1/touring/getTourConfigAndAvailability';

/**
 * get tour config and availability for a listing for a certain time period
 */
export const ZCalendarWebApiHandler_getTourConfigAndAvailability = (
  postData: GetTourConfigAndAvailabilityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetTourConfigAndAvailabilityWebApiRequestDto,
    GetTourConfigAndAvailabilityWebApiResponseDto
  >(
    {
      endpoint: ZCalendarWebApiHandler_getTourConfigAndAvailability_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getTourForSatelliteConversationId_Path =
  '/api/web/v1/touring/scheduling/getTourForSatelliteConversationId';

/**
 * get tour for satellite conversation id
 */
export const ZCalendarWebApiHandler_getTourForSatelliteConversationId = (
  getParams: GetTourForSatelliteConversationIdParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetTourForSatelliteConversationIdParams,
    never,
    GetTourForSatelliteConversationIdWebApiResponseDto
  >(
    {
      getParams: getParams,
      endpoint: ZCalendarWebApiHandler_getTourForSatelliteConversationId_Path,
      method: 'GET',
      contextPath: '/z-calendar',
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Path =
  '/api/web/v1/touring/getTouringTreatmentForZuidAndListing';

/**
 * get touring treatment status for irene zuid
 */
export const ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing = (
  postData: GetTouringTreatmentForZuidAndListingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetTouringTreatmentForZuidAndListingWebApiRequestDto,
    GetTouringTreatmentForZuidAndListingWebApiResponseDto
  >(
    {
      endpoint: ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_getToursForListing_Path = '/api/web/v1/touring/scheduling/getToursForListing';

/**
 * get tours for listing with optional bookedBy and tour status filter
 */
export const ZCalendarWebApiHandler_getToursForListing = (
  postData: GetToursForListingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetToursForListingWebApiRequestDto, GetToursForListingWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_getToursForListing_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_performTourAction_Path = '/api/web/v1/touring/scheduling/performTourAction';

/**
 * perform user-initiated tour actions from UX
 */
export const ZCalendarWebApiHandler_performTourAction = (
  postData: PerformTourActionWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, PerformTourActionWebApiRequestDto, PerformTourActionWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_performTourAction_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_removeAvailability_Path = '/api/web/v1/touring/availability/removeAvailability';

/**
 * remove tour availability
 */
export const ZCalendarWebApiHandler_removeAvailability = (
  postData: RemoveAvailabilityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RemoveAvailabilityWebApiRequestDto, RemoveAvailabilityWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_removeAvailability_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_saveTourFeedback_Path = '/api/web/v1/touring/scheduling/saveTourFeedback';

/**
 * save landlord response for tour feedback
 */
export const ZCalendarWebApiHandler_saveTourFeedback = (
  postData: SaveTourFeedbackWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SaveTourFeedbackWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_saveTourFeedback_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_setAvailabilitiesLite_Path =
  '/api/web/v1/touring/availability/setAvailabilitiesLite';

/**
 * bulk set tour availabilities for posting path
 */
export const ZCalendarWebApiHandler_setAvailabilitiesLite = (
  postData: SetAvailabilitiesLiteWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetAvailabilitiesLiteWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_setAvailabilitiesLite_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_setAvailability_Path = '/api/web/v1/touring/availability/setAvailability';

/**
 * set tour availability for a user and listing
 */
export const ZCalendarWebApiHandler_setAvailability = (
  postData: SetAvailabilityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetAvailabilityWebApiRequestDto, SetAvailabilityWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_setAvailability_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Path =
  '/api/web/v1/touring/config/storeListingCalendarTimeConfig';

/**
 * store custom calendar start and end times for a listing
 */
export const ZCalendarWebApiHandler_storeListingCalendarTimeConfig = (
  postData: StoreListingCalendarTimeConfigWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StoreListingCalendarTimeConfigWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_storeListingTimeZone_Path = '/api/web/v1/touring/config/storeListingTimeZone';

/**
 * store time zone for a listing
 */
export const ZCalendarWebApiHandler_storeListingTimeZone = (
  postData: StoreListingTimeZoneWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StoreListingTimeZoneWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_storeListingTimeZone_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_storeListingTourDuration_Path =
  '/api/web/v1/touring/config/storeListingTourDuration';

/**
 * store tour duration for a listing
 */
export const ZCalendarWebApiHandler_storeListingTourDuration = (
  postData: StoreListingTourDurationWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StoreListingTourDurationWebApiRequestDto, void>(
    {
      endpoint: ZCalendarWebApiHandler_storeListingTourDuration_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};

export const ZCalendarWebApiHandler_updateAvailability_Path = '/api/web/v1/touring/availability/updateAvailability';

/**
 * update tour availability
 */
export const ZCalendarWebApiHandler_updateAvailability = (
  postData: UpdateAvailabilityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateAvailabilityWebApiRequestDto, UpdateAvailabilityWebApiResponseDto>(
    {
      endpoint: ZCalendarWebApiHandler_updateAvailability_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};
